module.exports = __webpack_public_path__ + "img/call.6721c2bc.svg";